





































import { Vue, Component } from "vue-property-decorator";

import Personal from "./blocks/Personal.vue";
import Schedule from "./blocks/Schedule.vue";

import Menu from "@/components/common/Menu.vue";
import IconPhoneCalling from "@/components/icons/IconPhoneCalling.vue";
import IconSchedule from "@/components/icons/IconSchedule.vue";
import Logo from "@/components/icons/Logo.vue";

import { indexModule } from "@/plugins/store-accessors";

@Component({
  name: "app-header",
  components: {
    Menu,
    Personal,
    IconPhoneCalling,
    IconSchedule,
    Schedule,
    Logo,
  },
})
export default class Header extends Vue {
  get contacts() {
    return indexModule.getContacts;
  }

  get count() {
    return indexModule.getMeta?.on_sale_new_items_count;
  }
}
